import { jwtDecode } from 'jwt-decode'

import {
  IMPERSONATION_AMR,
  SESSION_FALLBACK,
  SESSION_FLAGS,
  SESSION_PARTS,
} from './constants'
import { GetAuthSessionKeyParams, JwtWithSessionData } from './types'

const decodeJwt = (token: string | null): JwtWithSessionData | null => {
  if (!token) {
    return null
  }

  try {
    return jwtDecode<JwtWithSessionData>(token)
  } catch {
    return null
  }
}

export const getAuthSessionKey = ({
  token,
  urlToken,
  buyerTokenMode,
}: GetAuthSessionKeyParams) => {
  const decoded = decodeJwt(token)
  const userId = decoded?.user_id || SESSION_FALLBACK.USER_ID
  const accountId = decoded?.account_id || SESSION_FALLBACK.VALUE
  const subject = decoded?.sub || SESSION_FALLBACK.VALUE
  const authState = decoded?.auth_state || SESSION_FALLBACK.VALUE
  const hasImpersonation = decoded?.amr?.includes(IMPERSONATION_AMR)
    ? SESSION_FLAGS.TRUE
    : SESSION_FLAGS.FALSE
  const activeUrlToken = urlToken || SESSION_FALLBACK.VALUE

  return [
    `${SESSION_PARTS.USER}:${userId}`,
    `${SESSION_PARTS.ACCOUNT}:${accountId}`,
    `${SESSION_PARTS.SUBJECT}:${subject}`,
    `${SESSION_PARTS.AUTH_STATE}:${authState}`,
    `${SESSION_PARTS.IMPERSONATION}:${hasImpersonation}`,
    `${SESSION_PARTS.BUYER_MODE}:${buyerTokenMode ? SESSION_FLAGS.TRUE : SESSION_FLAGS.FALSE}`,
    `${SESSION_PARTS.URL_TOKEN}:${activeUrlToken}`,
  ].join('|')
}
